const OURSTORY = (function () {
    const deviceChk = /iPhone|iPod|iPad|BlackBerry|Android|Windows CE|LG|MOT|SAMSUNG|SonyEricsson/i.test(navigator.userAgent) ? 'MOBILE' : 'PC';

    return {
        init: function () {
            this.event();
        },
        event: function () {
            $(".btn_scroll").on("click", function () {
                $("html,body")
                    .stop()
                    .animate({ scrollTop: $(".story_brand").offset().top - ($(".custom-header-group").outerHeight() ?? 0) + "px" }, 100);
            });
            // 스크롤 모션
            if (deviceChk !== "PC") {
                function scrollAnchor(target) {
                    let ts;
                    let te;
                    let wheel = true;
                    const wheelCont = document.querySelectorAll(target);
                    const wheelLastContTop = document.querySelector(".sclElm_last").offsetTop;
                    window.addEventListener("touchstart", function (e) {
                        ts = e.touches[0].clientY;
                    });
                    wheelCont.forEach(function (el, idx) {
                        el.addEventListener(
                            "touchmove",
                            function (e) {
                                let next = el.nextElementSibling;
                                let prev = el.previousElementSibling;
                                te = e.touches[0].clientY;
                                if (window.scrollY < wheelLastContTop) {
                                    if (e.cancelable) e.preventDefault();
                                    if (wheel) {
                                        wheel = false;
                                        if (ts > te) {
                                            if (next != null) {
                                                $("html,body").stop().animate({scrollTop: next.offsetTop + "px"});
                                            }
                                        } else {
                                            if (prev != null) {
                                                $("html,body").stop().animate({scrollTop: prev.offsetTop + "px"});
                                            }
                                        }
                                        setTimeout(function () {
                                            wheel = true;
                                        }, 120);
                                    }
                                }
                            },
                            { passive: false }
                        );
                    });
                }
                scrollAnchor(".sclElm");
            } else {
                // 스크롤 모션
                function scrollAnchor(target) {
                    let wheel = true;
                    const wheelCont = document.querySelectorAll(target);
                    const wheelLastContTop = document.querySelector(".sclElm_last").offsetTop;
                    wheelCont.forEach(function (el, idx) {
                        el.addEventListener(
                            "wheel",
                            function (e) {
                                let next = el.nextElementSibling;
                                let prev = el.previousElementSibling;
                                if (window.scrollY < wheelLastContTop - 10) {
                                    e.preventDefault();
                                    if (wheel) {
                                        wheel = false;
                                        if (e.deltaY > 0) {
                                            if (next != null) {
                                                $("html,body").stop().animate({scrollTop: next.offsetTop + "px"});
                                            }
                                        } else {
                                            console.dir(prev.className)
                                            if(prev.className != "breadcrumbs"){
                                                $("html,body").stop().animate({scrollTop: prev.offsetTop + "px"});
                                            }
                                        }
                                        setTimeout(function () {
                                            wheel = true;
                                        }, 1000);
                                    }
                                }
                            },
                            { passive: false }
                        );
                    });
                }
                scrollAnchor(".sclElm");
            }
            // 스크롤 모션

            // scroll active
            const io = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add("active");
                        } else {
                            entry.target.classList.remove("active");
                        }
                    });
                },
                {
                    threshold: 0.1,
                }
            );

            const aniList = document.querySelectorAll(".scroll_animation,.scroll_animation_half");
            aniList.forEach((el) => {
                io.observe(el);
            });

            // 비디오 재생 아이콘
            $(".play_btn").click(function () {
                $(this).fadeOut();
            });
            $(".interview_video .btn_more").click(function () {
                $(this).siblings(".video").children(".play_btn").fadeIn();
            });

            // 인터뷰 영상 노출
            $(".btn_right").click(function (e) {
                offsetY = window.pageYOffset;
                $("body").addClass("scrollDisable");
                $(this).parents(".brand_intro").next(".interview_video").addClass("on");
                e.preventDefault();
            });
            $(".btn_left").click(function () {
                $("body").removeClass("scrollDisable");
                $(window).scrollTop(offsetY);
                $(this).parents(".interview_video").removeClass("on");
            });
        },
        playHz: function (idn) {
            document.getElementById(idn).play();
            document.getElementById(idn).controls = true;
            setInterval(function () {
                if ($("#" + idn).prop("ended")) {
                    $("#" + idn)
                        .siblings(".play_btn")
                        .fadeIn();
                    document.getElementById(idn).controls = false;
                }
            }, 200);
        },
        pauseHz: function (idn) {
            document.getElementById(idn).pause();
            document.getElementById(idn).controls = false;
            $(".play_btn").fadeIn();
        },
    };
})();

$(document).ready(function () {
    OURSTORY.init();
});